import { useContext } from 'react';
import { shallowEqual } from 'react-redux';
import { Icon } from '@zillow/constellation-10';
import { IconMailFilled } from '@zillow/constellation-icons';

import { RMWContext } from '../../../../providers/RMWContext';
import { useSelector } from '../../../../selectors/useSelector';
import EmptyState from '../../../EmptyState';

type Props = {
  showScreeningCriteriaCTA?: boolean;
};

const EmptyInquiriesCardSimple = ({ showScreeningCriteriaCTA }: Props) => {
  const { paths } = useContext(RMWContext);

  const { listingAlias, isScreeningCriteriaSet } = useSelector((state) => {
    return {
      listingAlias: state.properties.propertyOverview.listingAlias,
      isScreeningCriteriaSet: state.properties.propertyOverview.screeningCriteria.isSet,
    };
  }, shallowEqual);

  const screeningCriteriaPath = `${paths.propertiesPage}/${listingAlias}/screening-criteria`;
  const screeningCriteriaLabel = isScreeningCriteriaSet ? 'Adjust screening preferences' : 'Set screening preferences';

  return (
    <EmptyState
      data-testid="EmptyInquiriesCardSimple"
      icon={<Icon render={<IconMailFilled />} size="md" css={{ color: 'icon.subtle' }} />}
      heading="No inquiries yet"
      headingLevel={4}
      align="left"
      body="When a renter contacts you, help make a good first impression by responding within 24 hours."
      secondaryAction={
        showScreeningCriteriaCTA ? { label: screeningCriteriaLabel, href: screeningCriteriaPath } : undefined
      }
    />
  );
};

export default EmptyInquiriesCardSimple;
